import React, { useState, useEffect } from "react";
import { useGlobalContext } from "../../../context/context";
import Cookies from "js-cookie";
import axios from "axios";
import LawMinerPlusSectionAndChapters from "./LawMinerPlusSectionAndChapters";
const CreateNewSubjectTree = ({ ID }) => {
  const {
    isTokenExpired,
    NewfetchRefreshToken,
    GetListSubject,
    Parents,
    GetSubjectTypeEnum,
    subjectsType,
    NewSubject,
    setNewSubject,
    fetchDataLwSubjectTree,LwTDataID,setLawTDataID,EditView, setEditView
    
  } = useGlobalContext();
  //   const [subjectsType, setSubjectsType] = useState([]);
  //   const [Parents, setParents] = useState([]);
  // const [LwTDataID,setLawTDataID]=useState(null)
  const [newInfo, setNewInfo] = useState({
    title: "",
    parentID: null,
    definition: "",
    ordering: 0,
    subjectType: 4,
    keywords: "",
    isPublic: true,
  });
  const CookieToken = JSON.parse(Cookies.get("token"));
  //   console.log(CookieToken.accessToken);
  //   const GetSubjectTypeEnum = async () => {
  //     try {

  //         await fetch(
  //           `${process.env.REACT_APP_BASE_URL_PROFILE}/v1/Global/GetSubjectTypeEnum`,
  //           {
  //             headers: {
  //               "Content-Type": "application/json",
  //               Authorization: `Bearer ${CookieToken.accessToken}`,
  //             },
  //           }
  //         )
  //           .then((res) => res.json())
  //           .then((data) => setSubjectsType(data.data));
  //     } catch (error) {
  //       console.log("error", error);
  //     }
  //   };

  //   const GetListSubject = async () => {
  //     try {
  //       let config = {
  //         method: "post",
  //         // maxBodyLength: Infinity,
  //         url: `${process.env.REACT_APP_BASE_URL_PROFILE}/v1/UserLwSubject/UserLwSubjectList`,
  //         headers: {
  //           Authorization: `Bearer ${CookieToken.accessToken}`,
  //           "Content-Type": "application/json",
  //         },
  //         data: JSON.stringify({
  //           filters: {
  //             pageNumber: 1,
  //             pageSize: 20,
  //             isSortAscending: true,
  //             sortField: "",
  //             search: "",
  //           },
  //           subjectType: 0,
  //         }),
  //       };
  //       await axios.request(config).then((res) => {
  //         const list = res.data;
  //         setParents(list.data.items);
  //       });
  //     } catch (error) {}
  //   };
  useEffect(() => {
    if (isTokenExpired(CookieToken.accessToken)) {
      NewfetchRefreshToken();
    } else {
      // GetSubjectTypeEnum();
      GetListSubject();
    }
  }, []);
console.log(Parents)
  const CreateNewSubject = () => {
    if (isTokenExpired(CookieToken.accessToken)) {
      NewfetchRefreshToken();
    } else {
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_BASE_URL_PROFILE}/v1/UserLwSubject/CreateUserLwSubject`,
        headers: {
          Authorization: `Bearer ${CookieToken.accessToken}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          title: newInfo.title,
          parentID: newInfo.parentID===null ? ID:newInfo.parentID,
          // definition: newInfo.definition,
          ordering: newInfo.ordering,
          subjectType: newInfo.subjectType,
          // keywords: newInfo.keywords,
          isPublic: newInfo.isPublic,
        }),
      };
      try {
        axios.request(config).then((res) => {
          console.log(res);
          if (res.status === 200) {
            alert("اطلاعات با موفقیت ثبت شد");
            setNewSubject(false);
            // setEditView(true)
            // setLawTDataID(res.data.data.data)
            fetchDataLwSubjectTree(ID)
          }
          // GetListSubject()
        });
      } catch (error) {}
    }
  };
  return (
    <>
      <div className="mt-7 py-3 w-full flex flex-col rounded-md px-5  bg-[#E0FBE2]">
        <section className="mb-3 font-bold text-[16px]">ایجاد موضوع</section>
        <div className=" gap-4 w-full grid md:grid-cols-3 grid-cols-1  items-center">
          <div className="w-full flex items-center ">
            <label className="w-[25%]  text-[14px] font-IranSans">
              عنوان موضوع:
            </label>
            <input
              className="border-2 rounded-md mr-3 w-full p-2 focus:outline-none"
              placeholder="عنوان موضوع"
              onChange={(e) =>
                setNewInfo((prev) => ({ ...prev, title: e.target.value }))
              }
            />
          </div>
          <div className="w-full flex items-center ">
            <label className="w-[25%]  text-[14px] font-IranSans">
              سرشاخه:
            </label>
            <select
              onChange={(e) =>
                setNewInfo((prev) => ({
                  ...prev,
                  parentID: Number(e.target.value),
                }))
              }
              className="border-2 font-IranSans rounded-md mr-3 w-full p-2 focus:outline-none"
            >
              <option></option>
              {Parents.length > 0 ? (
                Parents.map((item) => {
                  return (
                    <>
                      {item.id == ID ? (
                        <option selected value={item.id}>
                          {item.title}
                        </option>
                      ) : (
                        <option value={item.id}>{item.title}</option>
                      )}
                    </>
                  );
                })
              ) : (
                <option value={null}>موضوعی ثبت نشده است </option>
              )}
            </select>
          </div>

          {/* <div className="w-full flex items-center ">
            <label className=" w-[25%] text-[14px] font-IranSans">
              کلمات کلیدی :
            </label>
            <input
              onChange={(e) =>
                setNewInfo((prev) => ({ ...prev, keywords: e.target.value }))
              }
              className="border-2 rounded-md mr-3 w-full p-2 focus:outline-none"
              placeholder="کلمات کلیدی"
            />
          </div> */}
          <div className="w-full flex items-center ">
            <label className=" w-[25%] text-[14px] font-IranSans">
              ترتیب :
            </label>
            <input
              type="number"
              onChange={(e) =>
                setNewInfo((prev) => ({
                  ...prev,
                  ordering: Number(e.target.value),
                }))
              }
              className="border-2 rounded-md mr-3 w-full p-2 focus:outline-none"
              placeholder="ترتیب"
            />
          </div>

          {/* <div className="w-full flex items-center col-span-2">
            <label className="w-[10%]  text-[14px] font-IranSans">
              نوع موضوع :
            </label>
            <select
              onChange={(e) =>
                setNewInfo((prev) => ({
                  ...prev,
                  subjectType: Number(e.target.value),
                }))
              }
              className="border-2 rounded-md mr-3 w-full p-2 focus:outline-none"
              placeholder="نوع موضوع"
            >
              <option></option>
              {subjectsType.map((item) => {
                return <option value={item.value}>{item.text}</option>;
              })}
            </select>
          </div> */}
          {/* <div className="w-full flex items-center md:col-span-3  ">
            <label className=" ml-8  text-[14px] font-IranSans">توضیح:</label>
            <textarea
              onChange={(e) =>
                setNewInfo((prev) => ({ ...prev, definition: e.target.value }))
              }
              rows={3}
              cols={10}
              className="border-2 rounded-md mr-3 w-full p-2 focus:outline-none"
              placeholder="توضیح"
            />
          </div> */}
        </div>
        <div className="w-full ltr mt-3  px-5">
          <button
            onClick={CreateNewSubject}
            className="bg-[#14C38E] px-10 py-2 rounded-md text-white
           shadow-xl hover:border-[#14C38E] hover:bg-white hover:border-2 hover:text-[#14C38E]"
          >
            ثبت
          </button>
        </div>
        {/* <LawMinerPlusSectionAndChapters ID={newInfo.parentID} /> */}
      </div>
    </>
  );
};

export default CreateNewSubjectTree;
